import { render, staticRenderFns } from "./ProfilePhotoInput.vue?vue&type=template&id=0b1a0cf9&"
import script from "./ProfilePhotoInput.vue?vue&type=script&lang=ts&"
export * from "./ProfilePhotoInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports